module.exports = __webpack_public_path__ + "img/jindocoin-to-city.e43ca3d9.jpg";